export const getLocalStorageToken = (): string => {
  const value = window.localStorage.getItem('jwt')
  if (typeof value === 'string') {
    return value
  } else {
    return ''
  }
}

export const setLocalStorageToken = (value: string, cb?: () => void) => {
  if (value === '') {
    window.localStorage.clear()
  } else {
    window.localStorage.setItem('jwt', value)
  }

  if (cb) {
    cb()
  }
}
